import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import HeaderMenu from "./components/HeaderMenu/HeaderMenu";

const { Content } = Layout;

function AppLayout() {
  return (
    <Layout style={{ height: "100vh" }}>
      <HeaderMenu />
      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
}

export default AppLayout;
